import * as Yup from 'yup';
import * as React from 'react';
import { Mutation } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { Field, Formik, FieldProps, FormikProps, ErrorMessage } from 'formik';
import Span from '../../typography/Span';
import Label from '../../typography/Label';
import Box from '../../components/primitives/Box';
import { ValidateAdminUser } from '../../graphql';
import { StyledForm, Button, StyledFormGroup, StyledInput } from '../../components';

interface FormValues {
  firstName: string;
  lastName: string;
  password: string;
}

type AdminFormProps = RouteComponentProps & {
  id: string;
  otp: string;
  onComplete: (data: any) => void;
};

type AdminFormState = {
  showPassword: boolean;
};

const AcceptInviteValidationSchema = Yup.object().shape({
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
  password: Yup.string()
    .min(6, 'Please enter a password at least 6 digits long.')
    .required('Required'),
});

class AcceptAdminInviteForm extends React.Component<AdminFormProps, AdminFormState> {
  state = {
    showPassword: false,
  } as AdminFormState;
  render() {
    const { onComplete, id, otp } = this.props;
    const { showPassword } = this.state;
    return (
      <Mutation mutation={ValidateAdminUser} onCompleted={onComplete}>
        {(validateUser, { loading, error }) => (
          <Formik
            validationSchema={AcceptInviteValidationSchema}
            initialValues={{
              firstName: '',
              lastName: '',
              password: '',
            }}
            onSubmit={(values: FormValues) => {
              validateUser({
                variables: { id, otp, ...values },
              });
            }}
            render={(formikProps: FormikProps<FormValues>) => {
              return (
                <StyledForm data-testid="accept-admin-invite-form">
                  <Field
                    name="firstName"
                    render={({ field }: FieldProps<FormValues>) => (
                      <StyledFormGroup
                        // autocomplete notes:
                        // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
                        autoComplete="given-name"
                        {...field}
                        field={field}
                        form={formikProps}
                        label="First Name"
                      />
                    )}
                  />
                  <Field
                    name="lastName"
                    render={({ field }: FieldProps<FormValues>) => (
                      <StyledFormGroup
                        autoComplete="family-name"
                        {...field}
                        field={field}
                        form={formikProps}
                        label="Last Name"
                      />
                    )}
                  />
                  <Field
                    name="password"
                    render={({ field }: FieldProps<FormValues>) => (
                      <Box width="100%" mb={3}>
                        <Label>Password</Label>
                        <StyledInput
                          autoComplete="new-password"
                          px={2}
                          {...field}
                          showEyeIcon={true}
                          placeholder="Choose a password"
                          passwordVisible={showPassword}
                          type={showPassword ? 'text' : 'password'}
                          onTogglePassword={() =>
                            this.setState({
                              showPassword: !this.state.showPassword,
                            })
                          }
                        />
                        <ErrorMessage name="password">
                          {msg => (
                            <Span mt={2} color="error" textAlign="right">
                              {msg}
                            </Span>
                          )}
                        </ErrorMessage>
                      </Box>
                    )}
                  />
                  {error && (
                    <Span width="100%" textAlign="center" color="error" mb={3}>
                      {error.message.replace('GraphQL error:', '').trim()}
                    </Span>
                  )}
                  <Button isLoading={loading} type="submit" mt={2} text="SUBMIT" />
                </StyledForm>
              );
            }}
          />
        )}
      </Mutation>
    );
  }
}

export default withRouter(AcceptAdminInviteForm);



// WEBPACK FOOTER //
// ./src/forms/admin/AcceptAdminInviteForm.tsx